import { Component } from '@angular/core';

import type { FieldTypeConfig } from '@ngx-formly/core';
import { FieldType } from '@ngx-formly/core';

@Component({
	selector: 'formly-field-segmented-control',
	template: `
		<vp-segmented-control
			[forceHorizontal]="props['forceHorizontal']"
			[hasError]="showError"
			[id]="field.id"
			[isValid]="formControl.valid"
			[segmentedOptions]="props['segmentedOptions']"
			[value]="formControl.value"
			(selectedLabel)="updateValue($event)"
			ngDefaultControl
		/>
	`,
	standalone: false,
})
export class SegmentedControlComponent extends FieldType<FieldTypeConfig> {
	updateValue(value: string): void {
		this.formControl.patchValue(value);
	}
}
